// @ts-nocheck

import { createSelector } from 'reselect';

import { getBetIdFromProps, getOutcomesFromProps } from '../../selectors/_propsGetters_';
import { selectBetBoostedOddCardMode } from '../../selectors/bet.selector';
import { type CardMode } from '../../types/common';
import { type Selector, type SelectorMaker } from '../../types/selectors';

type OutcomeNbBSportAndOrderType = {
  outcomeNbBySport: { [any]: number };
  outcomeSportOrder: Array<number>;
};

type HistoryItemBetslipHeaderPropsType = OutcomeNbBSportAndOrderType & {
  cardMode: CardMode;
};

const selectOutcomeNbBySportAndOrder: Selector<OutcomeNbBSportAndOrderType> = createSelector(
  [getOutcomesFromProps],
  (outcomes) => {
    const outcomeNbBySport = {};
    const outcomeSportOrder = outcomes.map(({ category }) => {
      const sportId = category?.sportId;

      if (sportId) {
        if (outcomeNbBySport[sportId]) {
          outcomeNbBySport[sportId]++;
        } else {
          outcomeNbBySport[sportId] = 1;
        }
      }

      return sportId;
    });

    return { outcomeNbBySport, outcomeSportOrder };
  },
);

const selectSimpleBetBoostedCardMode: Selector<CardMode> = createSelector(
  [getBetIdFromProps, selectBetBoostedOddCardMode],
  (simpleBetId, cardMode) => {
    if (simpleBetId) {
      return cardMode;
    }
  },
);

const makeHistoryItemBetslipHeaderPropsSelector: SelectorMaker<HistoryItemBetslipHeaderPropsType> = () =>
  createSelector(
    [selectOutcomeNbBySportAndOrder, selectSimpleBetBoostedCardMode],
    ({ outcomeNbBySport, outcomeSportOrder }, cardMode) => ({
      outcomeNbBySport,
      outcomeSportOrder,
      cardMode,
    }),
  );

export default makeHistoryItemBetslipHeaderPropsSelector;
